import React, { useEffect, useState } from 'react';
import { _axios as axios } from '../../utils/auth';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import { url } from '../../utils';
import { useAppDispatch } from '../../store';
import { addAction, addCategory } from '../../store/mobileSlice';

const pageListName = {
  th: {
    actions: {
      title: 'กิจกรรม',
    },
    category: {
      title: 'ประเภท',
    },
  },
  en: {
    actions: {
      title: 'Activities',
    },
    category: {
      title: 'Categories',
    },
  },
  cn: {
    actions: {
      title: '动作',
    },
    category: {
      title: '类型',
    },
  },
};

interface ListItemsProps {
  listType: 'actions' | 'category';
  list: string;
}

const ListItems: React.FC<ListItemsProps> = ({ listType, list }) => {
  const dispatch = useAppDispatch();

  return (
    <>
      <ListItem component="div" disablePadding>
        <ListItemButton
          onClick={() => {
            if (listType === 'actions') {
              dispatch(addAction(list));
            }
            if (listType === 'category') {
              dispatch(addCategory(list));
            }
          }}>
          <ListItemText primaryTypographyProps={{ fontSize: 18 }} primary={list} />
        </ListItemButton>
      </ListItem>
      <Divider light />
    </>
  );
};

interface ListTypeMobileProps {
  listType: 'actions' | 'category';
  handlePopupSelected: (key: string, value: boolean) => void;
  language: 'th' | 'en' | 'cn';
}

interface ActionListType {
  name: string;
  value: string;
}

const ListTypeMobile: React.FC<ListTypeMobileProps> = ({ listType, handlePopupSelected, language }) => {
  const [isCancelSearchPopup, setIsCancelSearchPopup] = useState<boolean>(true);
  const [actionList, setActionList] = useState<ActionListType[]>([]);

  useEffect(() => {
    axios.get(`${url}/v1/${listType}?language=${language}`).then((response) => setActionList(response.data.data));
  }, []);

  return (
    <div
      className={`z-50 absolute bg-[#f3f3f3] w-screen h-screen top-0 right-0 py-6`}
      onClick={() => {
        handlePopupSelected(listType, false);
      }}>
      <Container>
        <IconButton
          className={`!absolute top-5 ${!isCancelSearchPopup && '!hidden'}`}
          onClick={() => handlePopupSelected(listType, false)}>
          <ArrowBackIosNewIcon />
        </IconButton>
        <Typography sx={{ mb: 2 }} variant="h6" className={`text-center ${!isCancelSearchPopup && '!hidden'}`}>
          {pageListName[language][listType].title}
        </Typography>
        <Box
          sx={{
            bgcolor: 'white',
            width: '100%',
            height: 'calc(100vh - (32px + 16px + 48px))',
            overflowY: 'auto',
          }}>
          <List dense disablePadding>
            {actionList.map((list) => (
              <ListItems key={list.value} listType={listType} list={list.name} />
            ))}
          </List>
        </Box>
      </Container>
    </div>
  );
};

export default ListTypeMobile;
